import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, Paper, Box } from "@mui/material";

import { Table, TabPanel } from "../../../../../components/ui";
import { TABLE_COLUMNS } from "./constants";
import { ICustomerBillingHistory, IPassersStats } from "../../../../../api/billing/index.types";

interface IProps {
  selectedRows: Array<number>;
}
interface IRenderTableProps {
  item: IPassersStats;
  loading: boolean;
  selectedAccountData: ICustomerBillingHistory[];
}

const RenderRable: React.FC<IRenderTableProps> = ({ item, loading, selectedAccountData }) => {
  return (
    <Table
      loading={loading}
      columns={TABLE_COLUMNS}
      data={selectedAccountData}
      extractKey={(row) => row.id}
      theadTitle={`Billing History ${item.email}`}
      csv_table_name={`Billing History ${item.email}`}
      isDownloadable
    />
  );
};

const BillingHistoryTabsByEmail: React.FC<IProps> = ({ selectedRows }) => {
  const { data, loading } = useSelector((state) => state.financials.passersStats);
  const [activeTabIndex, setActiveTab] = useState(0);
  const onChangeActiveTab = (_: React.BaseSyntheticEvent, newValue: number) =>
    setActiveTab(newValue);

  const tabsToRender = data.sumBillingHistory.filter((item) => !!selectedRows.includes(item.id));
  const selectedAccountData = data.billingHistory.filter(
    (item) => activeTabIndex === 0 || item.accounts_id === activeTabIndex
  );

  useEffect(() => {
    setActiveTab(0);
  }, [data]);

  return (
    <div>
      <Paper>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={activeTabIndex}
          indicatorColor="primary"
          onChange={onChangeActiveTab}
        >
          <Tab label="Billing History All" value={0} />

          {tabsToRender.map((item, i) => (
            <Tab key={item.id} label={item.email} value={item.id} />
          ))}
        </Tabs>
      </Paper>

      <Box sx={{ overflow: "scroll", maxHeight: "55vh" }}>
        {activeTabIndex ? (
          tabsToRender.map((item, i) => {
            return (
              <TabPanel key={item.id} value={activeTabIndex} index={item.id}>
                <RenderRable
                  item={item}
                  loading={loading}
                  selectedAccountData={selectedAccountData}
                />
              </TabPanel>
            );
          })
        ) : (
          <TabPanel value={activeTabIndex} index={0}>
            <RenderRable
              loading={loading}
              selectedAccountData={selectedAccountData}
              item={{ email: "All", id: 0, name: "", total_amount: 0, units_sold: 0 }}
            />
          </TabPanel>
        )}
      </Box>
    </div>
  );
};

export default BillingHistoryTabsByEmail;
